module.exports = __webpack_public_path__ + "img/buenos_aires_boedo.63675ae2.jpg";